<template>
    <div class="contact">
        <div class="top-white-box"></div>
        <div class="top-gray-box">
            <h1>Contact Us</h1>
        </div>
        <div class="page-wrapper">
            <div class="page-contents">

                <div class="contact-us-info-container" v-if="settings.contactEmail || settings.contactPhone">

                    <div class="info-wrapper">
                        <div class="info-container" v-if="settings.contactEmail">
                            <div class="info-label">Email</div>
                            <div class="info-data">{{settings.contactEmail}}</div>
                        </div>
                        <div class="info-container" v-if="settings.contactPhone">
                            <div class="info-label">Phone</div>
                            <div class="info-data">{{settings.contactPhone}}</div>
                        </div>
                    </div>
                </div>

                
                <div v-if="settings.contactPhone" class="contact-us-whatsapp">
                    <div>
                        Have a question or comment? Send us a message.<br /><br />
                    </div>
                    <a class="button" :href="whatsapp_msg_url" target="_blank">Contact Us Via WhatsApp</a>
                </div>
                <div v-else class="form-container">
                    <div>
                        Have a question or comment? Send us a message. Fill out the form below and click submit.
                    </div>
                    <div id="contact-us-form">
                        <div>
                            <label>Name</label>
                            <input placeholder="Your Name" id="name" name="name" v-model="form.name">
                        </div>
                        <div>
                            <label>Email</label>
                            <input placeholder="Your Email" id="email" name="email" v-model="form.email">
                        </div>
                        <div>
                            <label>Phone (optional)</label>
                            <input placeholder="Your Phone" id="phone" name="phone" v-model="form.phone">
                        </div>
                        <div>
                            <label>Message</label>
                            <textarea cols="400"
                                      rows="4"
                                      id="message"
                                      name="message"
                                      placeholder="Your Message"
                                      v-model="form.message"></textarea>
                        </div>
                        <div class="submit-button-container">
                            <button v-show="isBusy === false" class="button" @click="submitForm()" :disabled="isBusy == true || isValid == false">Submit</button>
                            <button v-show="isBusy === true" class="button">
                                <span class="icon"><img src="/Assets/img/spin.svg" /></span>
                            </button>
                            <span class="thank-you-message" v-if="showThankYouMessage">Thank you. We will be in touch soon.</span>
                        </div>
                    </div>
                    <div>
                        This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import api from "@/api";
    import settings from '@/settings'
    import { VueReCaptcha } from 'vue-recaptcha-v3'
    //Vue.use(VueReCaptcha, { siteKey: settings.vueReCaptchaSiteKey })

    export default {
        data() {
            return {
                isBusy: false,
                showThankYouMessage: false,
                form: {
                    name: '',
                    phone: '',
                    email: '',
                    message: '',
                    token: null,
                    whatsapp_msg_url: null
                }
            };
        },
        created() {
            document.title = settings.siteNameCaps + ' | Contact';
            Vue.use(VueReCaptcha, { siteKey: this.settings.vueReCaptchaSiteKey });
            this.whatsapp_msg_url = 'https://' + `wa.me/1${settings.contactPhone.replaceAll('.', '')}?text=Contact Us`;
        },
        computed: {
            isValid() {
                return (this.form.name !== '' && this.form.email !== '' && this.form.message !== '');
            },
            settings: function () {
                return settings;
            }
        },
        methods: {
            submitForm() {

                if (this.isValid) {
                    this.isBusy = true;
                    this.showThankYouMessage = false;

                    
                    this.$recaptcha("login").then(token => {
                        this.form.token = token;
                        api.submitContactUsForm(this.form).then(() => {
                            this.isBusy = false;
                            this.showThankYouMessage = true;
                        });
                    });
                }
            }
        }
    };
</script>
